/* eslint-disable @typescript-eslint/lines-between-class-members */
import { CreateOpportunityParams } from '../interfaces/opportunity';

class CreateOpportunityParamsModel {
  identificadorTransaccion: string;
  consentimiento?: boolean;
  procedencia: string;
  fechaTransaccion: string;
  canalVentas: string;
  fase: string;
  numeroDocumento: string;
  tipoDocumento: string;
  nombres?: string;
  apellidoPaterno?: string;
  apellidoMaterno?: string;
  correo?: string;
  telefonoCelular?: string;
  campania?: string;
  placaVehiculo?: string;
  marcaVehiculo?: string;
  modeloVehiculo?: string;
  anioVehiculo?: string | number;
  valorVehiculo?: string | number;
  zonaCirculacion?: string;

  constructor(dataOpportunity: CreateOpportunityParams) {
    this.identificadorTransaccion = dataOpportunity.tECId_c;
    this.consentimiento = dataOpportunity.tECConsentimiento_c;
    this.procedencia = dataOpportunity.tECFrom_c;
    this.fechaTransaccion = dataOpportunity.dEC_c;
    this.canalVentas = dataOpportunity.canalVentas ?? 'EC';
    this.fase = dataOpportunity.chECFase_c;
    this.numeroDocumento = dataOpportunity.tPerNumDoc_c;
    this.tipoDocumento = dataOpportunity.chPerTipoDoc_c;
    this.nombres = dataOpportunity.tPerNombre_c;
    this.apellidoPaterno = dataOpportunity.tPerApellidoPaterno_c;
    this.apellidoMaterno = dataOpportunity.tPerApellidoMaterno_c;
    this.correo = dataOpportunity.tPerCorreoElectronico_c;
    this.telefonoCelular = dataOpportunity.tPerTelefonoCelular_c;
    this.campania = dataOpportunity.tCampanaEC_c;
    this.placaVehiculo = dataOpportunity.tAutoPlaca_c;
    this.marcaVehiculo = dataOpportunity.tAutoMarca_c;
    this.modeloVehiculo = dataOpportunity.tAutoModelo_c;
    this.anioVehiculo = dataOpportunity.nAutoYear_c;
    this.valorVehiculo = dataOpportunity.cAutoValor_c;
    this.zonaCirculacion = dataOpportunity.tZona_c;
  }
}

export default CreateOpportunityParamsModel;
